"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDevicesByLocation = exports.getCurrentDevice = exports.updateDevice = void 0;
const shared_1 = require("@getgreenline/shared");
const updateDevice = (companyId, deviceId, updateDevice) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield shared_1.axios.put(`/api/v1/company/${companyId}/device/${deviceId}`, updateDevice);
    return response.data;
});
exports.updateDevice = updateDevice;
const getCurrentDevice = (includeSettings) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield shared_1.axios.get('/api/v1/device/me', {
        params: { includeSettings },
    });
    return response.data;
});
exports.getCurrentDevice = getCurrentDevice;
const getDevicesByLocation = (companyId, locationId, includeSettings) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield shared_1.axios.get(`api/v2/companies/${companyId}/location/${locationId}/devices`, {
        params: { includeSettings },
    });
    return response.data;
});
exports.getDevicesByLocation = getDevicesByLocation;
//# sourceMappingURL=deviceV2.js.map